/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { NotificationSelectionSummaryViewModel } from "../types/NotificationSelectionSummaryViewModel.ts";

export const notificationSelectionSummaryViewModelSchema = z.object({
  totalStudents: z.optional(
    z
      .number()
      .int()
      .describe(
        "Quantidade de alunos distintos que serão impactados pela notificação com base no filtro de turmas e status de matrícula.",
      ),
  ),
  totalClasses: z.optional(
    z
      .number()
      .int()
      .describe(
        "Quantidade de turmas consideradas no filtro. Quando IsAllClassStudents = true, retorna o total de turmas ativas.",
      ),
  ),
  totalEnrollmentStatus: z.optional(
    z
      .number()
      .int()
      .describe("Quantidade de status de matrícula informados no filtro."),
  ),
}) as unknown as ToZod<NotificationSelectionSummaryViewModel>;
